import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { GridPagination, useGridApiContext, useGridSelector, gridRowSelectionStateSelector } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
const CustomDataGridPaginationView = ({ selectedLabel }) => {
    const apiRef = useGridApiContext();
    const selectedRowCount = useGridSelector(apiRef, gridRowSelectionStateSelector).length;
    return (_jsxs(Box, { sx: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTop: "1px solid rgba(224,224,224,1)",
            paddingLeft: "20px",
            alignSelf: "stretch",
        }, children: [_jsx(Typography, { variant: "body2", color: "textSecondary", children: selectedRowCount > 0 && `${selectedRowCount} ${selectedLabel}${selectedRowCount > 1 ? "s" : ""} selected` }), _jsx(GridPagination, { rowsPerPageOptions: [] })] }));
};
export default CustomDataGridPaginationView;
